import { Component, OnInit } from '@angular/core';
import { Agent} from '../../../_models/agent';
import * as fromAgent from '../../../agent/state/agent.reducer';
import * as agentActions from '../../../agent/state/agent.actions';
import { UserGroup} from '../../../_models/user_group';
import * as fromUserGroup from '../../../userGroup/state/userGroup.reducer';
import * as fromRoot from '../../../state/app.reducer';
import * as rootActions from '../../../state/app.actions';
import { Store, select } from '@ngrx/store';
// import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './agent-edit-shell.component.html'
})

export class AgentEditShellComponent implements OnInit {

    // errorMessage$: Observable<string>;
    agent$: Observable<Agent>;
    userGroupList$: Observable<UserGroup[]>;

  constructor(
    private storeRoot: Store<fromRoot.State>,
    private store: Store<fromAgent.State>,
    private storeUserGroup: Store<fromUserGroup.State>
  ) {}

  ngOnInit() {

    this.agent$ = this.store.pipe(select(fromAgent.getCurrentAgent)) as Observable<Agent>;

    // Se obtienen los grupos de usuarios existentes.
    this.userGroupList$ = this.storeUserGroup.pipe(select(fromUserGroup.getUserGroupList)) as Observable<UserGroup[]>;

  }

  // NOTA: Las funciones realmente deberían quedar con una simple instrucción "dispatch".
  saveAgent(agentIn: Agent): void {

    console.log('---> saveAgent agentIn:');
    console.log(agentIn);

    if (agentIn.id === null) {
      console.log('Se va a CREAR un nuevo usuario.');
      this.store.dispatch( new agentActions.CreateAgent(agentIn));
    } else {
      console.log('Se va a MODIFICAR un usuario existente.');
      this.store.dispatch( new agentActions.UpdateAgent(agentIn));
    }
  }

  editAgent(e: Event) {
    console.log('-> -> Pulsado botón editAgent. Evento: ');
    console.log(e);

  }

  // --------------------------------------------------------------
  // Función para mostrar la ventana genérica de información.
  showInfoModal(modalParams) {

    console.log('---->>>>.... Ejecutando prodData-edit-shell showInfoModal: '
    + modalParams.value + ' ;Info: ' + modalParams.info + ' ;Link: ' + modalParams.link + ' ;Skin: ' + modalParams.skin);

    this.storeRoot.dispatch( new rootActions.ChangeInfoModal({
      value: modalParams.value,
      info: modalParams.info,
      link: modalParams.link,
      param: modalParams.param,
      skin: modalParams.skin
    }));

  } // End function showInfoModal


} // End class AgentEditShellComponent
